import { escapeAttr, escapeHtml } from "@emkit/builder-core";
import { looksLikeHtml, sanitizeRichHtml } from "./sanitize.js";
export const TABS_DEFAULTS = {
    items: [
        {
            id: "t1",
            title: "Overview",
            body: "Tabs group related content in a compact area. Edit each tab's body from the inspector.",
        },
        {
            id: "t2",
            title: "Features",
            body: "Each panel accepts plain text or rich HTML — sanitised at render time.",
        },
        {
            id: "t3",
            title: "Pricing",
            body: "Zero JavaScript: tabs switch via radio inputs and a scoped <style> block.",
        },
    ],
    defaultIndex: 0,
    align: "start",
    accent: "#111827",
};
const ALIGN_JUSTIFY = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    stretch: "stretch",
};
export const tabsWidget = {
    type: "tabs",
    defaultProps: TABS_DEFAULTS,
    renderHtml(props) {
        const items = props.items ?? [];
        if (items.length === 0) {
            return `<div class="emk-tabs" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(Empty tabs — add items in the inspector)</div>`;
        }
        // Scope radio inputs + CSS to this instance so multiple Tabs widgets
        // on the same page don't interfere with each other.
        const gid = `tabs-${Math.random().toString(36).slice(2, 8)}`;
        const active = Math.min(Math.max(props.defaultIndex ?? 0, 0), items.length - 1);
        const accent = props.accent ?? "#111827";
        const align = props.align ?? "start";
        const justify = ALIGN_JUSTIFY[align];
        const tabFlex = align === "stretch" ? "flex:1;" : "";
        const inputs = items
            .map((it, i) => {
            const checked = i === active ? " checked" : "";
            return `<input type="radio" name="${escapeAttr(gid)}" id="${escapeAttr(gid)}-${i}"${checked} style="position:absolute;opacity:0;pointer-events:none" aria-hidden="true">`;
        })
            .join("");
        const labels = items
            .map((it, i) => {
            return `<label for="${escapeAttr(gid)}-${i}" class="emk-tabs-tab" data-idx="${i}" style="${tabFlex}padding:10px 16px;cursor:pointer;font-weight:500;color:#6b7280;border-bottom:2px solid transparent;transition:color 0.15s,border-color 0.15s;text-align:center;user-select:none">${escapeHtml(it.title)}</label>`;
        })
            .join("");
        const panels = items
            .map((it, i) => {
            const body = looksLikeHtml(it.body)
                ? sanitizeRichHtml(it.body)
                : `<p>${escapeHtml(it.body).replace(/\n/g, "<br>")}</p>`;
            return `<div class="emk-tabs-panel" data-idx="${i}" style="display:none;padding:18px 4px;color:#374151;line-height:1.6">${body}</div>`;
        })
            .join("");
        // Scoped style: active radio highlights its label and shows its panel.
        // Using attribute selectors keeps everything inside the `.${gid}` root.
        const rules = items
            .map((_, i) => {
            const sel = `#${gid}-${i}:checked`;
            return `.${gid} ${sel}~.emk-tabs-nav .emk-tabs-tab[data-idx="${i}"]{color:${accent};border-bottom-color:${accent}}.${gid} ${sel}~.emk-tabs-panels .emk-tabs-panel[data-idx="${i}"]{display:block}`;
        })
            .join("");
        return `<div class="emk-tabs ${gid}" style="font-family:inherit"><style>${rules}</style>${inputs}<div class="emk-tabs-nav" role="tablist" style="display:flex;gap:4px;justify-content:${justify};border-bottom:1px solid #e5e7eb;overflow-x:auto">${labels}</div><div class="emk-tabs-panels">${panels}</div></div>`;
    },
};
//# sourceMappingURL=tabs.js.map